<!--
  - Navbar html code
  - Change password, logout , profile functionality
  - actiononClick() is called to navigate to particular navbar link like reports clients devices...
  - menuBtnOpen() is used to open or close side nav for profile , changePassword, logout options
  - Commented by sarthak on Feb 19, 2024
-->

<!--
  - If user is logged in then only this navabr is displayed
  - Depending upon user role different option in navbar are displayed
  - Commented by sarthak on Feb 19, 2024
 -->
<div *ngIf="isUserLoggedIn">
  <section class="example-section">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </section>
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <a class="navbar-brand">
      <img class="logo" *ngIf="DSPkey" src="./assets/img/brand/sailogo.png" />
      <img  *ngIf="sub_user_logo != null && !DSPkey; else notharman2" src="{{sub_user_logo}}" class="logo">
      <ng-template #notharman2>
        <img
        class="logo"
        *ngIf="!DSPkey"
        src="./assets/img/brand/enertics_logo_white_05x.png"
      />
      </ng-template>
      <img *ngIf="Cgkey" class="logo" src="./assets/img/brand/cg.png" />
    </a>
    <div
      class="collapse navbar-collapse"
      [ngClass]="{ show: shouldShow, hide: !shouldShow }"
      id="navbarCollapse"
    >
    <ul class="navbar-nav mr-auto">
      <li
        *ngFor="let option of options"
        (click)="actionOnClick(option.title)"
        class="nav-item"
      >
        <a
          [routerLink]="option.page"
          routerLinkActive="router-active"
          [ngStyle]="selectedNav === option.title ? {
            'color': '#fff',
            'background-color': 'transparent',
            'text-decoration': 'underline'
} : {}"
          class="nav-link"
        >
          {{ option.title }}
        </a>
      </li>
    </ul>
    
    </div>
    <form class="form-inline mt-2 mt-md-0">
      <img *ngIf="showRokadeLogo" src="../../../assets/img/brand/DOC-20241219-WA0003.png" class="logo" alt="">
      <button
        (click)="shouldShow = !shouldShow"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <span class="customer_name">
        <div class="name_user text-left">
          <span>{{ userName }}</span>
        </div>
        <div class="logged_as">
          Logged in as
          <span *ngIf="customer === 'CLIENT'">"{{ customer }} ADMIN"</span>
          <span *ngIf="customer === 'ADMIN'; else other"
            >"ENERTICS {{ customer }}"</span
          >
          <span *ngIf="customer !== 'CLIENT' && customer !== 'ADMIN'"
            >"{{ customer }}"</span
          >
        </div>
      </span>
      <div class="user_profle">
        <div
          class="user_img"
          [matMenuTriggerFor]="appMenu"
          (menuOpened)="menuBtnOpened()"
          (menuClosed)="menuBtnClose()"
        >
          <img
            class="custom-img"
            matListAvatar
            [src]="_userImg"
            onerror="this.src='./assets/img/brand/person-dummy.jpg';"
            alt="face"
          />
        </div>
        <!-- <mat-menu #appMenu="matMenu">
          <div id="profile_menu">
            <button mat-menu-item (click)="openProfile()">Profile</button>
            <button mat-menu-item (click)="openChangePassword()">
              Change Password
            </button>
            <button mat-menu-item (click)="onLogout()">Sign Out</button>
          </div>
        </mat-menu> -->
        <mat-menu #appMenu="matMenu">
          <div class="client_action" id="profile_menu">
            <div class="menu-item-container">
              <button mat-stroked-button color="primary" (click)="openProfile()" class="edit-button stroked-menu-button">
                <mat-icon>person</mat-icon>
                <span>Profile</span>
              </button>
            </div>
            <div class="menu-item-container">
              <button mat-stroked-button color="warn" (click)="openChangePassword()" class="delete-button stroked-menu-button">
                <mat-icon>password</mat-icon>
                <span>Change Password</span>
              </button>
            </div>
            <div class="menu-item-container">
              <button mat-raised-button color="warn" (click)="onLogout()" class="delete-button stroked-menu-button">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </mat-menu>
      </div>
    </form>
    <img
      *ngIf="DSPkey || sub_user_logo != null"
      class="logo"
      src="./assets/img/brand/enertics_logo_white_05x.png"
    />

    <img
      *ngIf="userID == 258 || CCAS_site_id == 258"
      class="logo"
      src="./assets/img/brand/DOC-20241219-WA0003.png"
    />
  </nav>
</div>

<!-- for cg -->
<div *ngIf="isUserLoggedIn && Cgkey">
  <section class="example-section">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </section>
  <nav
    class="navbar navbar-expand-md navbar-dark fixed-top bg-dark"
    style="
      background-color: #ffffff !important;
      padding: 8px 16px;
      border-bottom: 1px solid black;
    "
  >
    <a class="navbar-brand" style="color: #0e61ac">
      <!-- <img class="logo" src="./assets/img/brand/enertics_logo_white_05x.png"> -->
      <img class="logo" src="./assets/tricon.png" /> SMARTOR
    </a>
    <div
      class="collapse navbar-collapse"
      [ngClass]="{ show: shouldShow, hide: !shouldShow }"
      id="navbarCollapses"
    >
      <ul class="navbar-nav mr-auto">
        <li
          *ngFor="let option of options"
          (click)="actionOnClick(option.title)"
          class="nav-item"
        >
          <a>{{ option.title }}</a>
        </li>
      </ul>
    </div>
    <form class="form-inline mt-2 mt-md-0">
      <button
        (click)="shouldShow = !shouldShow"
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapses"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <span class="customer_names">
        <div class="name_users text-left">
          <span class="txtname">Welcome, {{ userName }}</span>
          <img
            class="custom-imgs"
            matListAvatar
            [src]="_userImg"
            onerror="this.src='./assets/img/brand/person-dummy.jpg';"
            alt="face"
          />
          <button
            mat-icon-button
            [matMenuTriggerFor]="appMenu"
            (menuOpened)="menuBtnOpened()"
            (menuClosed)="menuBtnClose()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <!-- <mat-menu #appMenu="matMenu">
            <div id="profile_menu">
              <button mat-menu-item (click)="openProfile()">Profile</button>
              <button mat-menu-item (click)="openChangePassword()">
                Change Password
              </button>
              <button mat-menu-item (click)="onLogout()">Sign Out</button>
            </div>
          </mat-menu> -->

          <mat-menu #appMenu="matMenu">
            <div class="client_action" id="profile_menu">
              <div class="menu-item-container">
                <button mat-stroked-button color="primary" (click)="openProfile()" class="edit-button stroked-menu-button">
                  <mat-icon>profile</mat-icon>
                  <span>Profile</span>
                </button>
              </div>
              <div class="menu-item-container">
                <button mat-stroked-button color="warn" (click)="openChangePassword()" class="delete-button stroked-menu-button">
                  <mat-icon>password</mat-icon>
                  <span>Change Password</span>
                </button>
              </div>
              <div class="menu-item-container">
                <button mat-stroked-button color="warn" (click)="onLogout()" class="delete-button stroked-menu-button">
                  <mat-icon>logout</mat-icon>
                  <span>Logout</span>
                </button>
              </div>
            </div>
          </mat-menu>
          <img
            class="cglogo"
            style="height: 40px; width: 45px"
            src="./assets/CG-logo1.png"
          />
        </div>
        <div class="logged_as">
          <!-- Logged in as <span *ngIf="customer==='CLIENT'">"{{customer}} ADMIN"</span> -->
          <!-- <span *ngIf="customer==='ADMIN';else other">"ENERTICS {{customer}}"</span>
            <span *ngIf="customer!=='CLIENT' && customer!=='ADMIN'">"{{customer}}"</span> -->
        </div>
      </span>
      <!-- <div class="user_profle"> -->
      <!-- <div class="user_img" [matMenuTriggerFor]="appMenu"  (menuOpened)="menuBtnOpened()" (menuClosed)="menuBtnClose()"> -->
      <!-- <img class="custom-img" matListAvatar [src]="_userImg"
              onerror="this.src='./assets/img/brand/person-dummy.jpg';" alt="face"> -->
      <!-- </div> -->
      <!-- <mat-menu #appMenu="matMenu">
            <div id="profile_menu">
               <button mat-menu-item (click)="openProfile()">Profile</button>
               <button mat-menu-item (click)="openChangePassword()">Change Password</button>
               <button mat-menu-item (click)="onLogout()">Sign Out</button>
            </div>
          </mat-menu> -->
      <!-- </div> -->
    </form>
  </nav>
</div>

<div class="example-container" id="page_container">
  <router-outlet></router-outlet>
</div>
